import { render, staticRenderFns } from "./user-dashboard-main.vue?vue&type=template&id=86ae648e&"
import script from "./user-dashboard-main.vue?vue&type=script&lang=js&"
export * from "./user-dashboard-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports